import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetJournalEntries, PostCreateJEAccrual, PostGenerateAccruals } from 'domain/usecases';

import { RemoteCreateJEAccruals } from 'data/usecases';

export const makeRemoteCreateJeAccruals = (): PostCreateJEAccrual => {
  return new RemoteCreateJEAccruals(makeApiUrl('/journal-entries/create'), makeAuthorizeHttpClientDecorator());
};
